/* eslint-disable no-console */
import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'uxd-design-system-components';
import './SaveResultsButton.scss';
import { sendToDelegator } from '../../api/index';
import { LocaleContext } from '../../contexts';
import getText from '../../assets/locale/locale';
import WebProspectFormModal from '../WebProspectFormModal/WebProspectFormModal';
import addDataLayerTrigger from '../../utils/addDataLayerTrigger/addDataLayerTrigger';
import getGaId from '../../utils/getGaId/getGaId';

const SaveResultsButton = ({
  resultsToSendToDelegator,
  setNotificationContent,
  setNotificationOpen,
  query,
  sessionId,
}) => {
  const locId = useContext(LocaleContext);
  const sourceForDelegator = 'web_prospect';

  const [displayWebProspectFormModal, setDisplayWebProspectFormModal] =
    useState(false);
  const [webProspectData, setWebProspectData] = useState(null);
  const [consentDateTimestamp, setConsentDateTimestamp] = useState('');
  const [savingResults, setSavingResults] = useState(false);
  const [saveResultsButtonDisabled, setSaveResultsButtonDisabled] =
    useState(false);

  const saveResultsButtonHandler = () => {
    addDataLayerTrigger('save-your-results-CTA');
    setDisplayWebProspectFormModal(true);
  };

  const successNotificationHandler = () =>
    getText(locId, 'Results', 'successNotification', 'SaveResultsButton');

  const saveResults = async () => {
    const sendToUserInd = 'Y';
    const sendToSfInd = 'Y';
    setSavingResults(true);

    addDataLayerTrigger('save-results-pop-up');
    let goldenId;
    try {
      const data = {
        results: resultsToSendToDelegator,
        webProspectData,
        consentDateTimestamp,
        persona: query,
        sessionId,
        gaId: getGaId(),
        queryString: window.location.search,
      };
      goldenId = await sendToDelegator({
        data,
        locId,
        sendToUserInd,
        sendToSfInd,
        utmSource: sourceForDelegator,
      });
      if (goldenId !== 'Processed Successfully!') {
        window.mcGlobal = goldenId;
        localStorage.setItem('mcGlobal', goldenId);
      }
      setSavingResults(false);
      setSaveResultsButtonDisabled(true);
      setNotificationContent({
        type: 'confirmation',
        text: successNotificationHandler(),
      });
      setNotificationOpen(true);
      addDataLayerTrigger('save-results-email-send');
    } catch (error) {
      console.error(error);
      setSavingResults(false);
      setNotificationContent({
        type: 'error',
        text: getText(locId, 'Results', 'errorMsg', 'SaveResultsButton'),
      });
      setNotificationOpen(true);
    }
  };

  return (
    <>
      <Button
        label={
          saveResultsButtonDisabled
            ? getText(locId, 'Results', 'successButton', 'SaveResultsButton')
            : getText(locId, 'Results', 'saveButton', 'SaveResultsButton')
        }
        disabled={saveResultsButtonDisabled}
        styleVariant="reversed-secondary"
        classes="button button-super save-results-button"
        loading={savingResults}
        attributes={{
          id: saveResultsButtonDisabled
            ? 'save-results-complete'
            : 'save-results',
          'data-testid': saveResultsButtonDisabled
            ? 'save-results-complete'
            : 'save-results',
        }}
        icon=""
        onClick={saveResultsButtonHandler}
      />
      <WebProspectFormModal
        displayWebProspectFormModal={displayWebProspectFormModal}
        setDisplayWebProspectFormModal={setDisplayWebProspectFormModal}
        webProspectData={webProspectData}
        setWebProspectData={setWebProspectData}
        consentDateTimestamp={consentDateTimestamp}
        setConsentDateTimestamp={setConsentDateTimestamp}
        saveResults={saveResults}
      />
    </>
  );
};

SaveResultsButton.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  resultsToSendToDelegator: PropTypes.object.isRequired,
  setNotificationContent: PropTypes.func.isRequired,
  setNotificationOpen: PropTypes.func.isRequired,
  query: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  sessionId: PropTypes.string.isRequired,
};

export default SaveResultsButton;
